import {
  CompetenceGraph,
  GraphSubtopic,
} from "@/components/CompetenceGraph/CompetenceGraph";
import { mcn } from "@/utils";
import React from "react";

export function YourInspiration(props: {
  topicName: string;
  graphSubtopics: GraphSubtopic[];
  showMobileFlipScreenTip: boolean;
}) {
  const { topicName, graphSubtopics, showMobileFlipScreenTip } = props;
  const motivationText = getMotivationText(topicName, graphSubtopics);
  return (
    <>
      <h2 className="text-style-headline3 text-light-yellow mb-md text-center">
        Your inspiration
      </h2>
      <p className="text-style-body1 text-center mb-sm">{motivationText}</p>
      <div className={mcn("flex justify-center mt-xl tablet:mt-xl")}>
        <div className="overflow-x-auto">
          <CompetenceGraph
            subtopics={graphSubtopics}
            showMobileFlipScreenTip={showMobileFlipScreenTip}
          />
        </div>
      </div>
    </>
  );
}

function getMotivationText(
  topicName: string,
  graphSubtopics: GraphSubtopic[]
): string {
  const motivatedSubtopics = graphSubtopics.filter((x) => x.isMotivated);
  const nrOfMotivatedSubtopics = motivatedSubtopics.length;
  switch (nrOfMotivatedSubtopics) {
    case 0:
      return `Based on your results you are inspired by the area ${topicName}.`;
    case 1:
      return `Based on your results you are inspired by the area ${topicName} and more specifically ${motivatedSubtopics[0].name}.`;
    case 2:
      return `Based on your results you are inspired by the area ${topicName} and more specifically ${motivatedSubtopics[0].name} and ${motivatedSubtopics[1].name}.`;
    case 3:
      return `Based on your results you are inspired by the area ${topicName} and more specifically ${motivatedSubtopics[0].name}, ${motivatedSubtopics[1].name} and ${motivatedSubtopics[2].name}.`;
    default:
      return `Based on your results you are inspired by the area ${topicName} and more specifically ${motivatedSubtopics[0].name}, ${motivatedSubtopics[1].name}, ${motivatedSubtopics[2].name} and more.`;
  }
}
